import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Alert } from 'antd';

import { translationNamespace } from '../../constants/translation-resources';

export const NoSelectedColumnsWarning: FC = () => {
  const { t } = useTranslation(translationNamespace);
  return <StyledAlert message={t('reports.single.noSelectedColumns')} type="warning" />;
};

const StyledAlert = styled(Alert)`
  text-align: center;
`;
